import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SideNavigation } from '@amzn/awsui-components-react';
import { usePermissions } from 'src/hooks/usePermissions';
import { TEST_CASE_AGENT_RUNTIME_ARN, isArnConfigured } from 'src/constants';

const SideNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeHref, setActiveHref] = useState(location.pathname);

  useEffect(() => {
    setActiveHref(location.pathname);
  }, [location.pathname]);

  const { canAccessAgent, canAccessUat } = usePermissions();

  const navigationItems = [
    {
      type: "section" as const,
      text: "Prompt Management",
      items: [
        {
          type: "link" as const,
          text: "All Tools",
          href: "/"
        }
      ]
    },
    {
      type: "section" as const,
      text: "Onboarding",
      items: [
        {
          type: "link" as const,
          text: "Onboarding Wizard",
          href: "/onboarding"
        }
      ]
    },
    {
      type: "section" as const,
      text: "Test Management",
      items: [
        {
          type: "link" as const,
          text: "Create Test Suite",
          href: "/testsuite/create"
        },
        {
          type: "link" as const,
          text: "Execute Test Suite",
          href: "/testsuite"
        },
        {
          type: "link" as const,
          text: "Test Suite Configuration",
          href: "/testsuite/config"
        }
      ]
    },
    ...(canAccessUat ? [{
      type: "section" as const,
      text: "UAT Testing",
      items: [
        {
          type: "link" as const,
          text: "UAT Sessions",
          href: "/uat"
        }
      ]
    }] : []),
    ...(canAccessAgent ? [{
      type: "section" as const,
      text: "Agents",
      items: [
        {
          type: "link" as const,
          text: "Tool Refinement Agent",
          href: "/agent"
        },
        ...(isArnConfigured(TEST_CASE_AGENT_RUNTIME_ARN) ? [{
          type: "link" as const,
          text: "Test Case Agent",
          href: "/test-case-agent"
        }] : [])
      ]
    }] : [])
  ];

  return (
    <SideNavigation
      activeHref={activeHref}
      header={{
        href: "/",
        text: "Bluey Tool Manager"
      }}
      items={navigationItems}
      onFollow={(event) => {
        if (!event.detail.external) {
          event.preventDefault();
          setActiveHref(event.detail.href);
          navigate(event.detail.href);
        }
      }}
    />
  );
};

export default SideNav;
